import { RSAA } from 'redux-api-middleware';

export const MULTIPLIK_SIGN = '/customer/multiplik/sign';
export const MULTIPLIK_SIGN_SUCCESS = '/customer/multiplik/sign/success';
export const MULTIPLIK_SIGN_FAILURE = '/customer/multiplik/sign/failure';

export const MULTIPLIK_SIGNATURE = '/customer/multiplik/signature';
export const MULTIPLIK_SIGNATURE_SUCCESS = '/customer/multiplik/signature/success';
export const MULTIPLIK_SIGNATURE_FAILURE = '/customer/multiplik/signature/failure';

export const MULTIPLIK_INVITATION_LINK = '/customer/multiplik/invitation-link';
export const MULTIPLIK_INVITATION_LINK_SUCCESS = '/customer/multiplik/invitation-link/success';
export const MULTIPLIK_INVITATION_LINK_FAILURE = '/customer/multiplik/invitation-link/failure';

export const MULTIPLIK_INVITATIONS = '/customer/multiplik/invitations';
export const MULTIPLIK_INVITATIONS_SUCCESS = '/customer/multiplik/invitations/success';
export const MULTIPLIK_INVITATIONS_FAILURE = '/customer/multiplik/invitations/failure';

export function getSignature() {
  return {
    [RSAA]: {
      endpoint: `/api/multiplik/signature`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [MULTIPLIK_SIGNATURE, MULTIPLIK_SIGNATURE_SUCCESS, MULTIPLIK_SIGNATURE_FAILURE],
    },
  };
}

export function sign() {
  return {
    [RSAA]: {
      endpoint: `/api/multiplik/sign`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [MULTIPLIK_SIGN, MULTIPLIK_SIGN_SUCCESS, MULTIPLIK_SIGN_FAILURE],
    }
  };
}

export function getInvitationLink() {
  return {
    [RSAA]: {
      endpoint: `/api/multiplik/invitation-link`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [MULTIPLIK_INVITATION_LINK, MULTIPLIK_INVITATION_LINK_SUCCESS, MULTIPLIK_INVITATION_LINK_FAILURE],
    },
  };
}

export function getInvitations() {
  return {
    [RSAA]: {
      endpoint: `/api/multiplik/invitations`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [MULTIPLIK_INVITATIONS, MULTIPLIK_INVITATIONS_SUCCESS, MULTIPLIK_INVITATIONS_FAILURE],
    },
  };
}
